module.exports = __webpack_public_path__ + "resources/img/bg-career-card2@2x.531ac1b7.jpg";